module.exports = __webpack_public_path__ + "img/isotipo_cidesa.e0c87f9.png";